// extracted by mini-css-extract-plugin
export var resizer = "_ge-0";